import { useForm } from "react-hook-form";
import { FormInput } from "../../components/FormInput";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";
import { F1020201Before, updateNewPcode } from "../../utility/service/personal-service";
import { checkDpSuccess } from "../../utility/service/tool-service";
import { MessageContext,handleSuccessMessage } from "../../store/messageStore";
import { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlertService } from "../../utility/service/alert-service";
import { addFormValidator } from "../../utility/validate/formValidator";
import { useEditableFlag } from '../../hooks/useEditableFlag';

const ChangePcode = () => {

  const { t } = useTranslation();
  const [, dispatch] = useContext(MessageContext); //訊息視窗  
  const navigate = useNavigate();
  const [formRule, setFormRule] = useState([]);//表單驗證
  const isEditable = useEditableFlag('F10202'); // Get editable status for F10202 function


  //表單驗證
  const registerOptions = {
    oriPcode: {
      required: t('validation.required'),
      pattern: {
        value: /^[A-Z0-9]{6,12}$/i,
        message: t('validation.passwordPattern')
      }
    },
    newPcode: {
      required: t('validation.required'),
      pattern: {
        value: /^[A-Z0-9]{6,12}$/i,
        message: t('validation.passwordPattern')
      }
    },
    confirmNewPcode: {
      required: t('validation.required'),
      validate: (val) => {
        // if (val?.length >= getValues("newPcode")?.length && watch('newPcode') !== val) return t('validation.confirm_password')
        if (watch('newPcode') !== val) return t('validation.confirm_password')
      },
      pattern: {
        value: /^[A-Z0-9]{6,12}$/i,
        message: t('validation.passwordPattern')
      }
    },


  }

  const {
    register,
    handleSubmit,
    watch,
    clearErrors,
    getValues,
    setValue,
    resetField,
    control,
    reset,
    formState: { errors, isValid, isDirty }
  } = useForm({
    defaultValues: {
      oriPcode: '',
      newPcode: '',
      newPcodeSecond: "",
    },
    //錯誤驗證時機
    mode: "all"
  });

  useEffect(()=>{
    axios_getCreateBefore();
  },[])

  const doubleCheckNewPcode = ()=>{
    let rule = setValidForm("confirmNewPcode");
    let newRules = {
      ...rule,
      validate: (val) => {
            if (watch('newPcode') !== val ) return t('validation.confirm_password')
          }
    }
    return newRules;
  }

//建立前查詢form 規則
const axios_getCreateBefore = ()=>{
  F1020201Before()
      .then((res)=>{
          if(checkDpSuccess(res)){
              let array = []
              res?.data?.RespBody?.constraints?.forEach((item) => {
                  const result = addFormValidator(item?.field, res.data.RespBody.constraints);
                  array.push(result)
              })
              setFormRule(array);
          }
      })
}

const setValidForm = useCallback((formId) => {
    if (formRule?.length > 0) {
        const tmp = formRule?.find((item) => {
            return Object.keys(item)[0] === formId
        });
        return tmp ? tmp[formId] : '';
    }
}, [formRule]);

  const onSubmit = (data) => {
    updateNewPcode({
      oriPcode:data.oriPcode,
      newPcode:data.newPcode,
      confirmNewPcode:data.confirmNewPcode
    })
      .then((res)=>{
        if(checkDpSuccess(res)){
          handleSuccessMessage(dispatch, t('changeSecret_info'));
          navigate('/login');

        }
      })
  }

  const handleBtnCancel = () => {
    reset();
  }

  return (
    <>
      <div className="p-card">
        <div className="p-card-body">
          <form onSubmit={handleSubmit(onSubmit)} className="grid">
            <div className="col-12 lg:col-6">
              {/* <FontAwesomeIcon icon="fa-solid fa-eye" />
                  <FontAwesomeIcon icon="fa-solid fa-eye-slash" /> */}
              <FormInput
                register={register}
                errors={errors}
                id="oriPcode"
                name="oriPcode"
                type="password"
                labelText={t('plz_enter_oldPwd')}
                labelClass="required"
                disabled={!isEditable}
                rules={setValidForm("oriPcode")}
              />
            </div>

            <div className="col-12 lg:col-6">
              <FormInput
                register={register}
                errors={errors}
                id="newPcode"
                name="newPcode"
                type="password"
                labelText={t('plz_enter_newPwd')}
                labelClass="required"
                disabled={!isEditable}
                rules={setValidForm("newPcode")}
              />
            </div>

            <div className="col-12 lg:col-6">
              <FormInput
                register={register}
                errors={errors}
                id="confirmNewPcode"
                name="confirmNewPcode"
                type="password"
                labelText={t('enter_newPwd_again')}
                labelClass="required"
                disabled={!isEditable}
                rules={doubleCheckNewPcode()}
              />
            </div>

            {/* Button替換區 */}
            <div className="col-12 gap-2 flex-all-center">
              <>
                <Button disabled={!isValid || !isDirty || !isEditable} type="submit" label={t("button.confirm")} size="small" />
                <Button outlined size="small" label={t("button.cancel")} onClick={(e) => {
                  e.preventDefault();
                  handleBtnCancel();
                }} />
              </>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default ChangePcode